import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_zngvnr6fff: FaireBrandEntity = {
  token: "b_zngvnr6fff",
  type: "brand",
  name: "Rookie Wellness",
  avatarUrl:
    "https://cdn.faire.com/fastly/c81ef1108ba1aa8565f65b0b11bb1bcfd75beaafe8c3632d35f28fae58bf2517.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/5f3dca7a869307a4f4ba4d10f133e11f0f58576060537d691fef72a5162116ef.png",
  logoUrl:
    "https://cdn.faire.com/fastly/c81ef1108ba1aa8565f65b0b11bb1bcfd75beaafe8c3632d35f28fae58bf2517.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5f3dca7a869307a4f4ba4d10f133e11f0f58576060537d691fef72a5162116ef.png",
  location: "Salt Lake City, UT, USA",
  minimumOrderDollars: 0,
  rating: 5,
  reviewCount: 5,
  isTopShop: true,
  isInsider: true,
  description:
    "Rookie began with a simple idea: wellness shouldn’t feel so overwhelming. Our founder, Roxanne, was trying to get back in shape after baby number two—while working full-time—and found the wellness world confusing, expensive, and hard to stick with.\n\nThat’s how Rookie was born: to make wellness simple, approachable, and effective. Whether you're just starting out or starting over, we believe small steps lead to big change. Our wellness drinks are designed for real life—messy schedules, busy mornings, post-gym slumps, and everything in between.\n\nOur signature greens superfood powders drink mix are packed with probiotic supplements, digestive enzymes, immune boosters, and antioxidant support to help you feel better from the inside out. Each blend is crafted with functional ingredients like ashwagandha powder to support mood, energy, hormonal balance, and inflammatory health—without the fluff.\n\nBeing a beginner isn’t a weakness—it’s your power. It means you’re brave enough to try. We’re here to support that with great-tasting, functional blends that work with you, not against you.\n\nFrom our Passion Guava Superfood Mix for gut health, to Coconut Pineapple BCAA+ for hydration, and Blackberry Lemon Sleep Aid to help you unwind, Rookie is here for your everyday wins.\n\nSo here’s to the Rookies: the brave ones who begin. Let’s make wellness feel like it belongs to all of us.\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:47.593Z",
    importedBy: "entity-db-cli",
  },
};
